import KeyFlowVO from './KeyFlowVO';

type StorageVOProps = {
  ID: number;
  NAME: string;
  MACSANPATH: string;
  MACNASPATH: string;
  WINSANPATH: string;
  WINNASPATH: string;
  WASPATH: string;
  SYMBOLICPATH: string;
  KIND: string;
  SMS_ALARM_LIMIT: number;
  CREATEDATE: string;
  CREATEUSER: string;
  MODIFYDATE: string;
  MODIFYUSER: string;
};

class StorageVO extends KeyFlowVO {
  id: number;
  name: string;
  macSanPath: string;
  macNasPath: string;
  winSanPath: string;
  winNasPath: string;
  wasPath: string;
  symbolicPath: string;
  kind: string;
  smsAlarmLimit: number;
  createDate: string;
  createUser: string;
  modifyDate: string;
  modifyUser: string;

  constructor(data: StorageVOProps) {
    super(data);
    this.id = data.ID;
    this.name = data.NAME;
    this.macSanPath = data.MACSANPATH;
    this.macNasPath = data.MACNASPATH;
    this.winSanPath = data.WINSANPATH;
    this.winNasPath = data.WINNASPATH;
    this.wasPath = data.WASPATH;
    this.symbolicPath = data.SYMBOLICPATH;
    this.kind = data.KIND;
    this.smsAlarmLimit = data.SMS_ALARM_LIMIT;
    this.createDate = data.CREATEDATE;
    this.createUser = data.CREATEUSER;
    this.modifyDate = data.MODIFYDATE;
    this.modifyUser = data.MODIFYUSER;
  }
}

export default StorageVO;
